import { Box, Stack, Typography } from '@mui/material'

import { i18WithDefault as t } from '@shared/locale'
import { ButtonActions } from 'components-ui/src/button_actions/button_actions'
import { SimpleModal } from 'components-ui/src/simple_modal/simple_modal'
import { ExternalStoredPaymentMethodClientDto } from 'service-api/src/types/api'

interface DeleteCardModalProps {
  card: ExternalStoredPaymentMethodClientDto | null
  onClose: () => Promise<void>
  onConfirm: () => Promise<void>
}

export const DeleteCardModal = ({ card, onClose, onConfirm }: DeleteCardModalProps) => {
  if (card?.usedInMembership) {
    return (
      <SimpleModal open onClose={onClose} sx={{ width: 'auto' }}>
        <Box sx={{ p: 1, maxWidth: 500 }}>
          <Stack spacing={2.5}>
            <Typography variant="h5" sx={{ maxWidth: 350 }}>
              {t('profile.paymentMethod.delete.title.usedInMembership')}
            </Typography>
            <Stack spacing={3}>
              <Typography variant="body1">{t('profile.paymentMethod.delete.usedInMembership_1')}</Typography>
              <Typography variant="body1">{t('profile.paymentMethod.delete.usedInMembership_2')}</Typography>
            </Stack>
            <ButtonActions
              onAction={onClose}
              onActionLabel={t('profile.paymentMethod.delete.ok')}
              actionVariant="secondary"
              actionButtonProps={{
                sx: { px: 1, py: 1.125 },
              }}
            />
          </Stack>
        </Box>
      </SimpleModal>
    )
  }

  return (
    <SimpleModal open onClose={onClose} sx={{ width: 'auto' }}>
      <Box sx={{ p: 1, maxWidth: 500, minWidth: 300 }}>
        <Stack spacing={2.5}>
          <Typography variant="h5">{t('profile.paymentMethod.delete.title')}</Typography>
          <Typography variant="body1">{t('profile.paymentMethod.delete.content')}</Typography>
          <ButtonActions
            onAction={onConfirm}
            onActionLabel={t('profile.paymentMethod.delete.confirm')}
            onCancel={onClose}
            onCancelLabel={t('profile.paymentMethod.delete.cancel')}
            actionVariant="error"
            actionButtonProps={{
              sx: { height: 35 },
              variant: 'text',
            }}
            cancelButtonProps={{
              sx: { height: 35 },
              variant: 'outlined',
            }}
          />
        </Stack>
      </Box>
    </SimpleModal>
  )
}
